import React from 'react';
import { Box } from '@mui/material';
import SafeImage from './SafeImage';

interface CountryFlagProps {
  src?: string;
  alt: string;
  width?: number;
  height?: number;
  sx?: React.CSSProperties | object;
}

const CountryFlag: React.FC<CountryFlagProps> = ({
  src,
  alt,
  width = 24,
  height = 16,
  sx
}) => {
  if (!src) {
    return (
      <Box
        sx={{
          width,
          height,
          bgcolor: 'grey.200',
          borderRadius: 1,
          display: 'inline-block',
          ...sx
        }}
      />
    );
  }

  return (
    <SafeImage
      src={src}
      alt={alt}
      width={width}
      height={height}
      fallbackSrc=""
      sx={{
        borderRadius: 1,
        objectFit: 'cover',
        ...sx
      }}
      onError={(e) => {
        const target = e.target as HTMLImageElement;
        target.style.display = 'none';
      }}
    />
  );
};

export default CountryFlag; 